// Versionsverlauf für den Info-Reiter: kommt beim Bauen aus CHANGELOG.md (neueste Version oben), je Version ein aufklappbarer Eintrag.
import changelog from '../../CHANGELOG.md?raw';

export interface ReleaseItem { heading: string; text: string; }
export interface ReleaseNote { version: string; items: ReleaseItem[]; }

/** Technische Standardhinweise, die Nutzern nichts sagen. */
const SKIP = /^(Keine Änderung am Teams-Manifest|Kein Manifest geändert|Übernimmt die (App-)?Baseline)/;

/** Markdown-Auszeichnung entfernen (**fett**, `Code`), damit der Text lesbar bleibt. */
function plain(text: string): string {
  return text.replace(/\*\*/g, '').replace(/`/g, '');
}

/** Punkt des Änderungsverlaufs in Überschrift und Text trennen: `- **Überschrift:** Text`; ohne Fettschrift dient der erste Satz als Überschrift. */
export function parseItem(line: string): ReleaseItem | undefined {
  const bold = /^\*\*(.+?)\*\*\s*(.*)$/.exec(line);
  if (bold) {
    const heading = plain(bold[1]).replace(/[:.]\s*$/, '').trim();
    const text = plain(bold[2]).trim();
    return heading ? { heading, text } : undefined;
  }
  const text = plain(line).trim();
  if (!text || SKIP.test(text)) return undefined;
  const sentence = /^(.{12,90}?)(?::\s|\.\s|$)/.exec(text);
  const heading = (sentence ? sentence[1] : text.slice(0, 90)).trim();
  return { heading, text };
}

export function parseReleaseNotes(source: string): ReleaseNote[] {
  const notes: ReleaseNote[] = [];
  let current: ReleaseNote | undefined;
  for (const line of source.split(/\r?\n/)) {
    const heading = /^##\s+(\d+\.\d+\.\d+)\b/.exec(line);
    if (heading) {
      current = { version: heading[1], items: [] };
      notes.push(current);
    } else if (current && line.startsWith('- ')) {
      const raw = line.slice(2).trim();
      if (SKIP.test(plain(raw).trim())) continue;
      const item = parseItem(raw);
      if (item) current.items.push(item);
    }
  }
  return notes.filter(note => note.items.length > 0);
}

export const releaseNotes: ReleaseNote[] = parseReleaseNotes(changelog);
